import { ItemWithPSAndLot } from './interface';

/**
 * A PREFILL item (from a landing page or widget) starts with example dimensions and weight. It still needs the
 * prefilled-item warning while the dimensions or the weight are those examples: the user has not touched them.
 * Picking a weight (range) counts as touching the weight, even when it lands on the example value.
 */
export const hasUntouchedPrefill = (item: ItemWithPSAndLot): boolean => {
  const prefilled = item.ps_temp.prefilled;
  if (item.ps_temp.origin?.type !== 'PREFILL' || !prefilled) return false;
  const dimensionsUntouched =
    item.length === prefilled.length && item.width === prefilled.width && item.height === prefilled.height;
  const weightUntouched = !item.weight_range && item.weight === prefilled.weight;
  return dimensionsUntouched || weightUntouched;
};
